import React from 'react';
import { Card, CardBody, Col } from 'reactstrap';
import { Image, LI, UL } from '../../../../AbstractElements';
import { Defaultitem1, Defaultitem2, Defaultitem3, Defaultitem5, WithImageRounded } from '../../../../Constant';
import HeaderCard from '../../../Common/HeaderCard';

const WithImageRound = () => {
  return (
    <Col sm='6' xl='6'>
      <Card>
        <HeaderCard title={WithImageRounded} />
        <CardBody>
          <UL className='default-list'>
            <LI className='list-group-item-action'>
              <Image body={true} className='rounded-circle' src={require('../../../../assets/images/user/1.jpg')} alt='' />
              {Defaultitem1}
            </LI>
            <LI className='list-group-item-action' tag='a' href='#javascript'>
              <Image body={true} className='rounded-circle' src={require('../../../../assets/images/user/1.jpg')} alt='' />
              {Defaultitem2}
            </LI>
            <LI className='list-group-item-action' tag='a' href='#javascript'>
              <Image body={true} className='rounded-circle' src={require('../../../../assets/images/user/1.jpg')} alt='' />
              {Defaultitem3}
            </LI>
            <LI className='list-group-item-action disabled'>
              <Image body={true} className='rounded-circle' src={require('../../../../assets/images/user/1.jpg')} alt='' />
              {Defaultitem5}
            </LI>
          </UL>
        </CardBody>
      </Card>
    </Col>
  );
};

export default WithImageRound;
